module.exports = __webpack_public_path__ + "static/colloidal_silver-a_novel_treatment_for_staphylococcus_aureus_biofilms-cecfb322afece69a34bd7217de371512.pdf";